import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    padding: theme.spacing(3),
  },
  spinner: {
    marginBottom: theme.spacing(2),
    color: '#40B9C3',
  },
  text: {
    color: '#666',
    fontSize: '1.1rem',
    fontWeight: 500,
    textAlign: 'center',
  },
  subtext: {
    color: '#999',
    fontSize: '0.9rem',
    textAlign: 'center',
    marginTop: theme.spacing(1),
  },
}));

const PageLoader = ({ 
  message = 'Loading...', 
  subtext = 'Please wait while we fetch your data',
  size = 48,
  showSpinner = true 
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {showSpinner && (
        <CircularProgress size={size} className={classes.spinner} />
      )}
      <Typography variant="h6" className={classes.text}>
        {message}
      </Typography>
      {subtext && (
        <Typography variant="body2" className={classes.subtext}>
          {subtext}
        </Typography>
      )}
    </div>
  );
};

export default PageLoader;
